__turbopack_context__.v({
  "bulletList": "BlockContent-module__79Qf6W__bulletList",
  "container": "BlockContent-module__79Qf6W__container",
  "h2": "BlockContent-module__79Qf6W__h2",
  "h3": "BlockContent-module__79Qf6W__h3",
  "link": "BlockContent-module__79Qf6W__link",
  "listItem": "BlockContent-module__79Qf6W__listItem",
  "numberedList": "BlockContent-module__79Qf6W__numberedList",
});
